import type { QueryAssetInput } from '@scio3/shared-types';

const TYPE_FIELDS = ['type', 'fileType', 'appType', 'commonType'] as const;
export type AssetTypeFields = {
  [K in (typeof TYPE_FIELDS)[number]]?: string | null;
};

/** Shared type restrictions for cached list insertion, browsing, and search.
 * Positive filters require a known matching value; exclusions allow missing fields.
 * This checks type restrictions only, not folder/security or other query predicates.
 */
export function matchesAssetTypeFilter(
  asset: AssetTypeFields,
  filter: Partial<QueryAssetInput>,
): boolean {
  for (const field of TYPE_FIELDS) {
    const value = asset[field];
    const equal = filter[field];
    const included = filter[`${field}_in`];
    const excluded = filter[`${field}_nin`];
    const notEqual = filter[`${field}_ne`];
    if (equal && value !== equal) return false;
    if (included && (value == null || !included.includes(value))) return false;
    if (excluded && value != null && excluded.includes(value)) return false;
    if (notEqual !== undefined && (value ?? null) === notEqual) return false;
  }
  return true;
}
